import React from 'react';
import styles from './ButtonLoadingSpinner.css';

const ButtonLoadingSpinner = props => {
  const { title, disabled } = props;
  return (
    <button
      type="button"
      className={`btn ml-10px active ${styles['button-spinner']}`}
      disabled={disabled}
    >
      <span> {title} </span>
      <i
        className={`fa fa-circle-o-notch fa-spin ${styles['spinner-color']}`}
      />
    </button>
  );
};

export default ButtonLoadingSpinner;
